import enLang from './en'
import frLang from './fr'
import deLang from './de'

export const Translations = {
  en: enLang,
  fr: frLang,
  de: deLang
}
